import * as CryptoJS from 'crypto-js';
import swal from "sweetalert";
import {authConstants} from "../constants/authConstants";
import i18next from "i18next";
import {apiUrls, appUrls, cookiePath, criptoKey, publicUrl} from "../constants/appUrls";
import * as Sentry from '@sentry/react';

export const handlerErrorMessage = (status, message = "") => {
  if (!status) return
  swal({
    icon: "error",
    text: i18next.t(`backCodeError.${status.toString()}`, {value: message}),
  });
  return false
}

export function setCookie(name, value, options = {}) {

  options = {
    path: cookiePath || "/",
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
}

export function getCookie(cName) {
  let name = cName + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const dataEncryption = (data) => {
  if(!data) return null
  return CryptoJS.AES.encrypt(data, criptoKey).toString();
}

export const requestURl = __REQUEST_URL__;
// export const requestURl = "https://stage.admin.adverton.pro/tmc";
export const domainCookie = window.location.hostname;

export const cookieOptions = {
  domain: domainCookie
}
export const setLoginCookie = (response) => {
  let options = {
    domain: domainCookie
  }
  setCookie(authConstants.accessToken, response.accessToken, options);
  setCookie(authConstants.refreshToken, response.refreshToken, options);
  setCookie(authConstants.typeToken, response.type, options);
  setCookie(authConstants.userId, response.userId, options);
  setCookie(authConstants.serviceToolsTokenAdmin, response.serviceToolsTokenAdmin, options);

}

export const delLoginCookie = () => {
  let cookieArr = [
    authConstants.accessToken,
    authConstants.refreshToken,
    authConstants.typeToken,
    authConstants.userId,
    authConstants.serviceToolsTokenAdmin,
    authConstants.tenant
  ];
  let options = {
    domain: domainCookie,
    'max-age': -1
  }
  let options2 = {
    domain: `.${domainCookie}`,
    'max-age': -1
  }
  let options3 = {
    domain: domainCookie,
    'max-age': -1,
    path: "/a"
  }
  let options4 = {
    domain: `.${domainCookie}`,
    'max-age': -1,
    path: "/a"
  }
  cookieArr.forEach(item => {
    setCookie(item, "", options);
    setCookie(item, "", options2);
    setCookie(item, "", options3);
    setCookie(item, "", options4);
  });

  const cookies = document.cookie.split(";");
  console.log("cookies", cookies)
  cookies.forEach(cookie => {
    const [name] = cookie.split("=").map(c => c.trim()); // Извлекаем имя куки
    // Del all cookie form all the set path
    // if (name === "cookieAgreement") return
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domainCookie};`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domainCookie};`;
  });

  // return new Promise(function (resolve) {
  //   return resolve(true);
  // })
  // setCookie(authConstants.accessToken, "", options);
  // setCookie(authConstants.refreshToken, "", options);
  // setCookie(authConstants.typeToken, "", options);
  // setCookie(authConstants.userId, "", options);
  // setCookie(authConstants.language, "", options);
  // setCookie(authConstants.hasPrivilege, "", options);
}

export const refreshTokenForWebsocket = async () => {
  const currentRefreshToken = getCookie(authConstants.refreshToken);

  const body = {
    refreshToken: currentRefreshToken
  }
  let token = await fetch(`${requestURl}${apiUrls.checkAccessToken}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })

  if (token.status === 401) {
    delLoginCookie();
    unAuthModal("");
    return;
  }

  let tokenResult = token.json();

  const bodyForRefresh = {
    refreshToken: getCookie(authConstants.refreshToken)
  }
  const currentTenant = getCookie(authConstants.tenant);
  const refreshResult = await fetch(`${requestURl}${apiUrls.refreshToken}`, {
    method: "POST",
    body: bodyForRefresh ? JSON.stringify(bodyForRefresh) : null,
    credentials: 'include',
    headers: {
      "X-Tenant-Id": currentTenant,
      Authorization: tokenResult.type + " " + tokenResult.accessToken,
      "Content-Type": "application/json",
    }
  })

  if (refreshResult.status === 401) {
    delLoginCookie();
    unAuthModal("");
    return
  } else {
    const refreshResultData = refreshResult.json();
    refreshResultData && setLoginCookie(refreshResultData);
  }

  return refreshResult

}

export const unAuthModal = (url) => {
  return swal({
    icon: "warning",
    text: url === appUrls.login ? i18next.t("checkYourData") : i18next.t("relogin")
  }).then(() => {
    if (url !== appUrls.login) {
      window.location.href = `${publicUrl}/login`;
    }
  })
}
